import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Typography,
  Box,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
  Chip,
  Card,
  CardActionArea,
  CardContent,
} from '@mui/material';

export function ConfirmDialog({ open, title, message, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel' }) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{cancelLabel}</Button>
        <Button variant="contained" onClick={onConfirm} color="primary">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function EmptyState({ icon: Icon, title, description, actionLabel, onAction }) {
  return (
    <Paper sx={{ p: 4, textAlign: 'center' }}>
      {Icon && <Icon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />}
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Typography color="text.secondary" paragraph>{description}</Typography>
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction}>{actionLabel}</Button>
      )}
    </Paper>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <Alert severity="error" action={onRetry && <Button color="inherit" size="small" onClick={onRetry}>Retry</Button>}>
      {message}
    </Alert>
  );
}

export function SuccessBanner({ message, onClose }) {
  return (
    <Alert severity="success" onClose={onClose} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
}

export function ViewToggle({ value, onChange, options }) {
  return (
    <ToggleButtonGroup value={value} exclusive onChange={(e, v) => v != null && onChange(v)} size="small" sx={{ mb: 2 }}>
      {options.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value}>{opt.label}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

export function ListCard({ title, subtitle, status, to, onClick }) {
  return (
    <Card>
      <CardActionArea component={to ? Link : 'div'} to={to || undefined} onClick={onClick}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Typography variant="subtitle1" fontWeight={600}>{title}</Typography>
            {status && <Chip label={status} size="small" color={status === 'Approved' ? 'success' : status === 'Pending' ? 'warning' : status === 'Confirmed' || status === 'Passed' || status === 'Active' ? 'success' : 'default'} />}
          </Box>
          {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export function ScreenFrame({ title, actions, children }) {
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight={600}>{title}</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box>
      </Box>
      {children}
    </>
  );
}
